<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatterPage" id="fm">
<p class="paraY1">Books by Terrence J. Winschel</p>
<p class="paraY"><em class="italic">Triumph and Defeat:</em></p>
<p class="paraNoIndentY"><em class="italic">The Vicksburg Campaign </em>(1998)</p>
<p class="paraY"><em class="italic">Vicksburg:</em></p>
<p class="paraNoIndentY"><em class="italic">Fall of the Confederate Gibraltar </em>(1999)</p>
<p class="paraY"><em class="italic">The Civil War Diary of a Common Soldier:</em></p>
<p class="paraNoIndentY"><em class="italic">William Wiley of the 77th Illinois Infantry</em>(2001)</p>
<p class="paraY"><em class="italic">Vicksburg is the Key:</em></p>
<p class="paraNoIndentY"><em class="italic">The Struggle for the Mississippi River </em>(2003)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_fm.vue?6d51f180